import ListViewLeftPart from '../../components/AreasComponent/ListViewLeftPart/ListViewLeftPart';

import withDefaultProps from './withDefaultProps';

export default withDefaultProps(ListViewLeftPart);
